import React, { useState, useCallback } from "react";
import { useEffect } from "react";
import {
Button,
Form,
FormGroup,
Media,
Spinner,
Input,
Alert,
Label,
} from "reactstrap";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { T, TF, LanguageList, Config } from "react-translator-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightToBracket } from "@fortawesome/free-solid-svg-icons";
import {Translator} from 'react-translator-component';
import { translate } from "../../language/translations.js";


const Unsubscribe = () =>{
    //first thing, get values from url
    let [searchParams, setSearchParams] = useSearchParams();
    let idUrl = searchParams.get("id");
    let emailUrl = searchParams.get("email");
    let languageUrl = searchParams.get("lang");
    let loungeCodeUrl = searchParams.get("code");
    //let envArsLmsUrl = searchParams.get("env");
    //let isProdEnv = searchParams.get("prd");

    Config.default = languageUrl;
    localStorage.setItem("rtc-lang",languageUrl);

    const pageUrl = window.location.href;
    let s3Url = process.env.REACT_APP_S3_PREFIX;
    let isProdEnv = process.env.NODE_ENV === "production" && !pageUrl.includes('qa') ? true : false;
    let envUrl = "";
    let envArsLms = pageUrl.includes("lms") ? "lms" : "ars";
    let loungeCode = !pageUrl.includes("localhost")
      ? loungeCodeUrl//pageUrl.substring(pageUrl.lastIndexOf("/") + 1) 
      : process.env.REACT_APP_TEST_LOUNGE_CODE;
    let initialPassengerState = {
    env: "",
    isProd: false,
    loungeCode: "",
    loungeName: "",
    language: "",
    waitlistEmailLogo: "",
    s3Url: "",
    name: "",
    email: "",
    phoneNumber: "",
    departureTime: "",
    guests: "0",
    };
     

    let [email, setEmail] = useState("");
    let [recordID, setRecordID] = useState(0);
    let [language, setLanguage] = useState(0);
    const [imgUrl, setImgUrl] = useState("");
    const [img, setImg] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(idUrl?false:true);
    const [showError, setShowError] = useState(false);

     // List of Languages and files for translation text
  Config.list = {
    en: {
      text: "English",
      icon: "./flags/en.svg",
      file: translate.en,
    },
    es: {
      text: "Español",
      icon: "./flags/es.svg",
      file: translate.es,
    },
    pt: {
      text: "Portuguese",
      icon: "./flags/pt.svg",
      file: translate.pt,
    },
  };

    const createS3Url = () => {
        if (isProdEnv) {
          s3Url += pageUrl.includes("lms")
            ? process.env.REACT_APP_LMS_S3_BUCKET
            : process.env.REACT_APP_ALDPOS_S3_BUCKET;
        } else {
          s3Url += pageUrl.includes("lms")
            ? process.env.REACT_APP_LMS_S3_BUCKET
            : process.env.REACT_APP_ALDPOS_S3_BUCKET;
        }
    
        return s3Url;
    };
    s3Url = createS3Url();

    // build ENV url based on URL when loading. Defaults to ARS
    const createEnvUrl = () => {
        let newUrl = "";

        if (isProdEnv) {
        if (!pageUrl.includes("qa")) {
            newUrl = pageUrl.includes("aldpos")
            ? process.env.REACT_APP_ALDPOS_API_PROD
            : process.env.REACT_APP_LMS_API_PROD;
        }
        } else if (!isProdEnv){
        if (pageUrl.includes("qa")) {
            newUrl = pageUrl.includes("aldpos")
            ? process.env.REACT_APP_ALDPOS_API_DEV
            : process.env.REACT_APP_LMS_API_DEV;
        } else {
            newUrl = process.env.REACT_APP_API_LOCAL_URL
        }      
        }
        return newUrl;
    };
    envUrl = createEnvUrl();  

// Make API call to get Lounge Logo file name
  // build up S3 Bucket string depending on ENV/LoungeCode
  // set the obj url to Img component on render.
    const FetchLoungeInfo = async() => {
    let tempImgUrl = s3Url + process.env.REACT_APP_S3_BUCKET_IMAGES;
    await axios({
        method: "post",
        url: envUrl + "getLoungeInfo",
        data: {
        env: envArsLms,
        code: loungeCode,
        isProd: isProdEnv
        },
    })
        .then((res) => {   
        setImg(true)
        tempImgUrl += res.data.WaitlistEmailLogo;
        setImgUrl(tempImgUrl);
        setImg(true)
        setLoading(false)
        })
        .catch((err) => {
            setShowError(true);
        });
    };

    const handleConfirmation = () =>{
        //submit changes
        setLoading(true);
        if(!recordID)
            return setShowError(true);
        axios({
        method: "post",
        url: envUrl + "addToWaitlist",
        data: {
            ...initialPassengerState,
            id:parseInt(recordID)
        },
        }).then((res) => {
            setLoading(false);
            if (res.data.statusCode !== 200) {
                setShowError(true);
            } else if (res.status !== 200) {
                setShowError(true);
            } else {
            setIsSuccess(true);
            window.history.replaceState(null, "Wait List", "/Unsubscribe");
            }
        })
        .catch((err) => {
            setLoading(false);
            setShowError(true);
        });
        //show success message.
    }

    let CloseTab = (e) =>{
        window.close();
    }

    useEffect(() => {
        setRecordID(idUrl);
        setEmail(emailUrl);
        setLanguage(languageUrl);
        FetchLoungeInfo();
        setTimeout(() => {
            Config.default = "";
            localStorage.setItem("rtc-lang","");
        }, 2000);
    }, []);

    return (
        <div style = {{flex: "auto",
            minHeight: 100,
            overflow: "hidden"}}>
        <Translator>
            <div style={style.UnsubscribeForm}>
            <Media id="loungeLogo">
                <img src={imgUrl} alt="" />
            </Media>
            {
                isSuccess?
                (<div style = {style.description}>{T("Your email has been successfully removed.")}</div>)
                :
                (<div style = {style.description}>{T("Your email")} {email} {T("will be removed and will no longer be used to contact you.") }<br/> {T("Please click the button below to confirm.")}</div>)
            }
            
                <Form id="passengerForm" inline="true" >
                <FormGroup floating>
                    {loading ? (
                        <Button id="spinnerBtn" color="primary" style={style.UnsubscribeBtn} disabled>
                            <Spinner id="submitSpinner" size="sm" />
                            <span>
                            {" "}
                            {T("...processing request")}
                            </span>
                        </Button>
                        ) : (
                            isSuccess?(
                            <Button disabled={!isSuccess} style={style.UnsubscribeBtn} onClick={CloseTab}>
                                {T("Close")}
                            </Button>
                                ):
                                (
                            <Button disabled={isSuccess} style={style.UnsubscribeBtn} onClick={handleConfirmation}>
                                {T("Confirm")}
                            </Button>

                                )
                        )}
                </FormGroup>
                {
                    showError?
                    (
                        <Alert id="alert" color="danger" fade={true}>
                            Request failed please try again
                        </Alert>
                    ):
                    null
                }
                </Form>
            </div>
        </Translator>
    </div>
    );
};

const style = {
    UnsubscribeForm:{
        padding:0,
        marginTop:100
    },
    UnsubscribeBtn:{
        width: 300,
    },
    description:{
        marginBottom:20,
        marginTop:20,
    }
}

export default Unsubscribe;